import React from "react"
import { Container, Row, Col } from "react-bootstrap"
import "./assets/styles/_index.scss"
const { ContentModule } = require("@starberry/gatsby-theme-utils/Modules/ContentModule")
const { CTALink } = require("@starberry/gatsby-theme-utils/Modules/CTALinkModule")

const SpaceFeatures = ({ data, additionalclass }) => {
    var facData = data?.add && data?.add?.length > 0 ? data?.add : data?.add_amenity && data?.add_amenity?.length > 0 ? data?.add_amenity : ""
    return (
        <section className={`space-features-wrapper section-p104 ${additionalclass}`}>
            <Container>
                <Row>
                    <Col xl={4}>
                        {data?.services_intro && <ContentModule Content={data.services_intro?.data?.services_intro} />}
                        {data?.intro && <ContentModule Content={data.intro?.data?.intro} />}
                        {data?.cta_link && <CTALink class="button button-primary" link={data.cta_link} title={data.cta_title} target_window={data.cta_link.target_window} />}
                    </Col>
                    <Col xl={1}></Col>
                    <Col xl={7}>
                        <div className="space-features-grid-wrapper">
                            {
                                facData && facData?.length > 0 && facData.map((item, index) => (
                                    <div className="space-features-card" key={index}>
                                        {/* <i className={`icon ${feature?.icon}`}></i> */}
                                        <img src={item?.icon?.url} alt={item?.title} />
                                        <div className="space-features-card-title">{item?.title}</div>
                                        <div className="space-features-card-desc d-md-block d-none">{item?.content && <ContentModule Content={item.content?.data?.content} />}</div>
                                    </div>
                                )
                                )
                            }
                        </div>
                    </Col>
                </Row>
            </Container>
        </section>
    )
}

export default SpaceFeatures